import { render, staticRenderFns } from "./AllReminders.vue?vue&type=template&id=4aa66ae0&scoped=true&"
import script from "./AllReminders.vue?vue&type=script&lang=js&"
export * from "./AllReminders.vue?vue&type=script&lang=js&"
import style0 from "./AllReminders.vue?vue&type=style&index=0&id=4aa66ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa66ae0",
  null
  
)

export default component.exports